import classnames from 'classnames'

export const cn = classnames
export default classnames
